import { render, staticRenderFns } from "./ReviewImageDialog.vue?vue&type=template&id=74141f96&scoped=true"
import script from "./ReviewImageDialog.vue?vue&type=script&lang=js"
export * from "./ReviewImageDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewImageDialog.vue?vue&type=style&index=0&id=74141f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74141f96",
  null
  
)

export default component.exports